import React, { Component } from 'react'
import { staticAssetsPrefix, isDarkMode, saveLocally } from '../../lib/utils';
import { IS_DARK_MODE } from '../../lib/strings';
import { Switch } from 'antd';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { toggleDarkTheme } from '../../actions';

// import { ReactComponent as MoonIcon } from "../../public/assets/svg/moon.svg";
// import { ReactComponent as SunIcon } from "../../public/assets/svg/sun.svg";

class ThemeOptions extends Component {
    constructor(props) {
        super(props);
        this.state = { foregroundColor: 'lightgray', bgColor: 'gray' };
    }
    componentDidMount() {
        // setTimeout(() => {
        //     if (isDarkMode()) {
        //         this.props.toggleDarkTheme(1);
        //     }
        // }, 300);
    }

    onChangeTheme = () => {
        // const { isDarkTheme } = this.state;
        const { settingsState } = this.props;
        const isDarkTheme = settingsState.themeVal == 1;
        const newThemeVal = !isDarkTheme;
        // this.setState({ isDarkTheme: checked });
        this.props.toggleDarkTheme(newThemeVal ? 1 : 0);
        saveLocally(IS_DARK_MODE, newThemeVal);

        if (newThemeVal) {
            this.setState({ foregroundColor: 'gray', bgColor: 'lightgray' });
        } else {
            this.setState({ foregroundColor: 'lightgray', bgColor: 'gray' });
        }
        this.setState({ isDarkTheme: newThemeVal });
    }

    render() {
        const { settingsState } = this.props;
        const { foregroundColor, bgColor } = this.state;
        const isDarkTheme = settingsState.themeVal == 1;
        return (
            <div style={{}}>
                <label className="toggle-wrapper" htmlFor="toggle">
                    <div className={`toggle ${isDarkTheme ? "enabled" : "disabled"}`}>
                        <span className="hidden">
                            {isDarkTheme ? "Enable Light Mode" : "Enable Dark Mode"}
                        </span>
                        <div className="icons">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.995 12C6.995 14.761 9.241 17.007 12.002 17.007C14.763 17.007 17.009 14.761 17.009 12C17.009 9.239 14.763 6.993 12.002 6.993C9.241 6.993 6.995 9.239 6.995 12ZM11 19H13V22H11V19ZM11 2H13V5H11V2ZM2 11H5V13H2V11ZM19 11H22V13H19V11Z" />
                                <path d="M5.63702 19.778L4.22302 18.364L6.34402 16.243L7.75802 17.657L5.63702 19.778Z" />
                                <path d="M16.242 6.34405L18.364 4.22205L19.778 5.63605L17.656 7.75805L16.242 6.34405Z" />
                                <path d="M6.34402 7.75902L4.22302 5.63702L5.63802 4.22302L7.75802 6.34502L6.34402 7.75902Z" />
                                <path d="M19.778 18.3639L18.364 19.7779L16.242 17.6559L17.656 16.2419L19.778 18.3639Z" />
                            </svg>

                            <svg style={{ fill: 'white' }} width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 11.807C10.7418 10.5483 9.88488 8.94484 9.53762 7.1993C9.19037 5.45375 9.36832 3.64444 10.049 2C8.10826 2.38205 6.3256 3.33431 4.92899 4.735C1.02399 8.64 1.02399 14.972 4.92899 18.877C8.83499 22.783 15.166 22.782 19.072 18.877C20.4723 17.4805 21.4245 15.6983 21.807 13.758C20.1625 14.4385 18.3533 14.6164 16.6077 14.2692C14.8622 13.9219 13.2588 13.0651 12 11.807V11.807Z" />
                            </svg>
                        </div>
                        <input
                            id="toggle"
                            name="toggle"
                            type="checkbox"
                            checked={isDarkTheme}
                            // onClick={this.onChangeTheme}
                            onChange={this.onChangeTheme}
                        />
                    </div>
                </label>
                <style jsx>
                    {`
                        :root {
                            // --black: #333333;
                            // --white: #f5f5f5;
                            // --backround: var(--white);
                            // --foreground: var(--black);
                            --transition: 0.5s ease;
                          }
                        .hidden {
                            clip: rect(0 0 0 0);
                            clip-path: inset(50%);
                            height: 1px;
                            overflow: hidden;
                            position: absolute;
                            white-space: nowrap;
                            width: 1px;
                          }
                          
                          .toggle-wrapper {
                            // width: 130px;
                            display: block;
                            margin: auto; /* Centering for demo */
                          }
                          
                          .toggle {
                            height: 28px;
                            width: 72px;
                            background: ${foregroundColor}; // var(--foreground);
                            border-radius: 40px;
                            padding: 12px 2px;
                            position: relative;
                            transition: background var(--transition);
                            cursor: pointer;
                          }
                          
                          .toggle::before {
                            content: "";
                            display: block;
                            height: 20px;
                            width: 20px;
                            border-radius: 30px;
                            background: ${bgColor}; // var(--background);
                            position: absolute;
                            z-index: 2;
                            transform: translate(10px, -8px);
                            transition: transform var(--transition), background var(--transition);
                          }
                          
                          .toggle.enabled::before {
                            transform: translate(38px, -8px);
                          }
                          
                          .toggle input {
                            opacity: 0;
                            position: absolute;
                            top: 0;
                          }
                          
                          .toggle .icons {
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            height: 100%;
                            margin: 0 5px;
                          }
                          
                          .toggle .icons svg {
                            fill: var(--background);
                            height: 20px;
                            width: 32px;
                            z-index: 0;
                          }
                    `}
                </style>
            </div>
        )
        // return (
        //     <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        //         <div style={{ padding: '0 4px' }}>
        //             <Switch checked={isDarkTheme} onChange={this.onChangeTheme} />
        //         </div>
        //         <p style={{ fontSize: '12px', marginTop: '2px' }}>DARK</p>
        //     </div>
        // )
    }
}

ThemeOptions.propTypes = {
    settingsState: PropTypes.object,
    toggleDarkTheme: PropTypes.func,
}

const mapStateToProps = (state) => {
    return {
        settingsState: state.settingsState,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        toggleDarkTheme: bindActionCreators(toggleDarkTheme, dispatch),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ThemeOptions);
